import React from 'react';
import classes from '../GenericCourses.module.css';

import OfferBanner from '../../../components/OfferBanner';

import companiesBannerImage from "../../../assets/company-banner.png";
import companyPhoto2 from "../../../assets/company2.jpg";
import { HashLink } from 'react-router-hash-link';
import { useTranslation } from "react-i18next";
import { useMediaQuery } from 'react-responsive'

const CompanyCourses = () => {
    const { t } = useTranslation('translation');
    const hygraph = t;

    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1199px)' });

    return (
        <section id="description">
        <div>
            <OfferBanner bannerImage={companiesBannerImage}
                bannerAlt="imagine de prezentare a serviciilor pentru companii"
                bannerTitle={hygraph('Courses.Company.Title')}
            ></OfferBanner>

            <div className={classes.masonryWithColumns}>
                <div dangerouslySetInnerHTML={{ __html: hygraph('Courses.Company.Section1')} } className={!isTabletOrMobile ? classes.offerSection : classes.offerSectionMobile} />
                <div className={classes.offerSection}>
                    <div className={classes.imageFrame}>
                        <img src={companyPhoto2} alt='office workers'>
                        </img>
                    </div>
                </div>
                <div dangerouslySetInnerHTML={{ __html: hygraph('Courses.Company.Section2')} } className={classes.offerSection} />
            </div>

            <div className={classes.registryButton}>
                <HashLink smooth={true} to='/register#form'>
                    <button className='primary-button big-button'>
                        {hygraph('Courses.Company.ButtonLabel')}
                    </button>
                </HashLink>
            </div>
        </div>
        </section>
    )
}

export default CompanyCourses;
